function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 26.58V31H19V26.58C20.7562 26.0874 22.3592 25.1586 23.66 23.88L27.5 26.1L30.5 20.9L26.66 18.68C27.1133 16.9221 27.1133 15.0779 26.66 13.32L30.5 11.1L27.5 5.9L23.66 8.12C22.3592 6.84141 20.7562 5.91261 19 5.42V1H13V5.42C11.2438 5.91261 9.64078 6.84141 8.34 8.12L4.5 5.9L1.5 11.1L5.34 13.32C4.88665 15.0779 4.88665 16.9221 5.34 18.68L1.5 20.9L4.5 26.1L8.34 23.88C9.64078 25.1586 11.2438 26.0874 13 26.58V26.58Z",
  stroke: "#32D882",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.34 13.38C16.9407 13.1237 16.4744 12.9914 16 13C14.9 13 14 13.68 14 14.5C14 15.32 14.9 16 16 16C17.1 16 18 16.68 18 17.5C18 18.32 17.1 19 16 19C15.5256 19.0086 15.0593 18.8763 14.66 18.62",
  stroke: "#32D882",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16 11V13",
  stroke: "#32D882",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16 19V21",
  stroke: "#32D882",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgVenueManagment10 = function SvgVenueManagment10(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVenueManagment10, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/venue-managment10.bfcd7476.svg";
export { ForwardRef as ReactComponent };